import { render } from "./NsiTnvedCardHistory.vue?vue&type=template&id=51b31848&scoped=true"
import script from "./NsiTnvedCardHistory.vue?vue&type=script&lang=js"
export * from "./NsiTnvedCardHistory.vue?vue&type=script&lang=js"

import "./NsiTnvedCardHistory.vue?vue&type=style&index=0&id=51b31848&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b31848"]])

export default __exports__